/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_DeletingInputs */



/**
* | output |
* | --- |
* | "Deleting API Key. Please wait..." |
*
* @param {Options_Api_Keys_DeletingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_deleting = /** @type {((inputs?: Options_Api_Keys_DeletingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_DeletingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Suppression de la clé API. Veuillez patienter...")
	if (locale === "de") return /** @type {LocalizedString} */ ("API-Schlüssel wird gelöscht. Bitte warten...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Eliminazione della chiave API. Attendi...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удаление ключа API. Пожалуйста, подождите...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminando clave API. Espere...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在删除 API 密钥。请稍候……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("APIキーを削除しています。お待ちください...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एपीआई कुंजी हटाई जा रही है। कृपया प्रतीक्षा करें...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Excluindo a chave da API. Aguarde...")
	return /** @type {LocalizedString} */ ("Deleting API Key. Please wait...")
});